import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';


@Injectable({ providedIn: 'root' })
export class SalesOrders_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
  }

    public Utilities: Utilities_OperationService;
  public SalesOrders: SalesOrders_OperationService = this;

  public Disable_MergeOrdersOntoSingleShipment = {
    isAuthorized: (): Promise<boolean> => {
      return this.isAuthorized('Disable_MergeOrdersOntoSingleShipment');
    },
    isAssigned: (): Promise<boolean> => {
      return this.isAuthorized('Disable_MergeOrdersOntoSingleShipment');
    }
  }

  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/SalesOrders/operations/${operationName}/isauthorized`, null);
  }
}
